import { ImpactOrderVariant, RefPrefix } from '../../types';

export const impactOrderVariantToRefPrefix: Record<ImpactOrderVariant, RefPrefix> = {
  [ImpactOrderVariant.ADMIN_PANEL]: RefPrefix.AdminPanel,
  [ImpactOrderVariant.API]: RefPrefix.Api,
  [ImpactOrderVariant.FLIGHT_CALCULATOR]: RefPrefix.FlightCalculator,
  [ImpactOrderVariant.IMPACT_SHOP]: RefPrefix.ImpactShop,
  [ImpactOrderVariant.INTEGRATION]: RefPrefix.Integration,
  [ImpactOrderVariant.SUBSCRIPTION]: RefPrefix.Subscription,
};
